export default __webpack_public_path__ + "static/media/in_store_pl.7ed4a5b8.svg";